import React, {memo, useState} from 'react';
import {Button, Icon, Input, PriorityIcon} from '@priority-software/priority-style-react';
import {texts} from '../../../../texts';
import styles from '../../../../styles.module.scss';
import {isRTL} from '../../../../../../../../../Localization';

export type Props = {
    title: string;
    onSave: (value: string) => void;
    onClose: () => void;
};

export const AdvancedSearchTitle = memo(({title, onSave, onClose}: Props) => {
    const [inputTitle, setInputTitle] = useState(title);

    const save = () => {
        if (inputTitle.length) {
            onSave(inputTitle);
            onClose();
        }
    };

    return (
        <>
            <Input
                value={inputTitle}
                onChange={e => setInputTitle(e.target.value)}
                componentClasses={styles.input}
                direction={isRTL() ? 'rtl' : 'ltr'}
                skin="line"
                prefixIcon={<Icon iconColor="dark-purple" icon={PriorityIcon.filter} />}
                autoFocus
            >
                <Icon
                    onClick={onClose}
                    icon={PriorityIcon.closeSmall}
                    componentClasses={styles.editIcon}
                />
            </Input>

            <Button onClick={save} size="medium" skin="text" componentClasses={styles.dropdownBtn}>
                {texts.save}
            </Button>
        </>
    );
});
